import WithRender from "../../templates/layouts/layoutStockDefaultPdf.html";

export default WithRender({});
